import { render } from "./bottoms.vue?vue&type=template&id=49c6372f&scoped=true"
import script from "./bottoms.vue?vue&type=script&lang=js"
export * from "./bottoms.vue?vue&type=script&lang=js"

import "./bottoms.vue?vue&type=style&index=0&id=49c6372f&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c6372f"]])

export default __exports__